import React from "react";
import { ConservativeValue } from "common/types/common.types";
import { getLithuanianDateString } from "common/helpers/dateStringHelpers";
import { useTranslation } from "react-i18next";
import colors from "common/styles/colors";

interface ConservativeValueInfoProps {
  conservativeValue: ConservativeValue;
}

export const ConservativeValueInfo: React.FC<ConservativeValueInfoProps> = ({
  conservativeValue,
}) => {
  const { t } = useTranslation();

  const { bkprm_percent, date, excel_link } = conservativeValue;

  const parts: string[] = [];
  if (bkprm_percent !== undefined) {
    parts.push(`BKPRM ${bkprm_percent.toFixed(2)} %`);
  }
  if (date) {
    parts.push(getLithuanianDateString(date));
  }

  return (
    <div
      style={{
        marginTop: "8px",
        fontSize: "12px",
        color: colors.grey,
        textAlign: "right",
      }}
    >
      <sup>1</sup> {parts.join(" · ")}
      {!!excel_link && (
        <>
          {parts.length > 0 ? " · " : ""}
          <a
            href={excel_link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: colors.grey, textDecoration: "underline" }}
          >
            {t("conservativeValueInfo.sourceLink")}
          </a>
        </>
      )}
    </div>
  );
};
